import React, { Component } from 'react'
import styled from 'styled-components'
import {
  SortableContainer,
  arrayMove
} from 'react-sortable-hoc'
import pickBy from 'lodash.pickby'
import { FormattedMessage } from 'react-intl'

import { MdAdd, MdStorage, MdDateRange, MdStar, MdInfo, MdCloudDownload } from 'react-icons/md'

import Modal from '../../molecules/Modal'

import LayerBoxItem from '../../atoms/LayerBoxItem'

const LayerContainer = styled.div`
  position: relative;
  padding-top: 10px;
  padding-bottom: 30px;
`

const ButtonAddLayer = styled.button`
  position: absolute;
  bottom: -20px;
  left: 50%;
  width: 180px;
  height: 40px;
  padding: 0;
  line-height: 35px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #00a79d;
  transform: translateX(-50%);
  border: none;
  border-radius: 40px;
  cursor: pointer;
  outline: none;

  svg,
  span {
    display: inline-block;
    vertical-align: middle;
  }

  svg {
    position: relative;
    top: -1px;
    margin-right: 8px;
    font-size: 28px;
  }
`

const TableList = styled.div`
  max-height: 397px;
  overflow-y: ${props => props.itemsLength > 1 ? 'scroll' : 'initial'};
  font-size: 14px;
`

const TableBody = styled.div`
  padding: 0 0.5rem;
  position: relative;
  z-index: 0;
`

const BoxTitle = styled.h2`
  display: block;
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  color: #65a49e;
`

const InfoContent = styled.div`
  padding: 20px;
`

const InfoList = styled.ul`
  padding-left: 20px;
  margin-bottom: 40px;
  margin-top: 20px;
  list-style: none;

  li {
    margin-bottom: 12px;
  }

  .info-list__label,
  .info-list__value {
    font-size: 14px;
  }

  .info-list__label,
  .info-list__value,
  .info-list__label svg,
  .info-list__label span,
  .info-button svg,
  .info-button span {
    display: inline-block;
    vertical-align: middle;
  }

  .info-list__label {
    margin-right: 10px;
    font-weight: 600;
  }

  .info-list__label svg {
    display: inline-block;
    margin-right: 6px;
    font-size: 20px;
  }

  .info-list__value {
    font-weight: 500;
  }
`

const InfoLink = styled.a`
  display: inline-block;
  height: 40px;
  padding: 0 20px;
  margin-right: 32px;
  line-height: 40px;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background-color: #00a79d;
  border: none;
  border-radius: 40px;
  cursor: pointer;
  outline: none;

  &:hover {
    color: white;
  }

  svg,
  span {
    display: inline-block;
    vertical-align: middle;
  }

  svg {
    position: relative;
    top: -1px;
    margin-right: 8px;
    font-size: 22px;
  }
`

const SortableList = SortableContainer(({
  layerActions: { deleteLayer, editLayer, sortLayers },
  layers,
  onMetadataClick
}) =>
  <TableBody>
    {layers.layers
      .map((layer, key) => {
        const isFirstItem = layers.layers[0].id === layer.id;
        const layerData = layers.data.find(item => item.nm_layer === layer.id);
        const layerLegendData = pickBy(layers.legends, (_value, key) => key.startsWith(`legend.layer.${ layerData.id_layer }.`))

        return ([
          <LayerBoxItem
            isFirstItem={isFirstItem}
            layer={layer}
            layerData={layerData}
            legendData={layerLegendData}
            editLayer={editLayer}
            sortLayers={sortLayers}
            deleteLayer={deleteLayer}
            key={`item-${key}`}
            index={key}
            onMetadataClick={ onMetadataClick.bind(this) }
          />
        ])
      })}
  </TableBody>
)


const onSort = ({ layerActions, layers }) =>
  ({ oldIndex, newIndex }) => {
    const nLayers = arrayMove(layers.layers, oldIndex, newIndex)

    layerActions.sortLayers(nLayers)
  }

class LayerBox extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeLayer: null
    }
  }

  setActiveLayer(layer) {
    this.setState({ activeLayer: layer })
  }

  removeActiveLayer() {
    this.setState({ activeLayer: null })
  }

  renderMetadataContent() {
    const { activeLayer } = this.state
    const { metadata } = activeLayer

    return (
      <InfoContent>
        <p><FormattedMessage id={ metadata.descript } /></p>
        <InfoList>
          <li className="info-list__list">
            <span className="info-list__label">
              <MdStorage />
              <FormattedMessage id="layer.metadata.src" />
            </span>
            <span className="info-list__value">{ metadata.source }</span>
          </li>
          <li className="info-list__list">
            <span className="info-list__label">
              <MdDateRange />
              <FormattedMessage id="layer.metadata.year" />
            </span>
            <span className="info-list__value">{ metadata.date }</span>
          </li>
          <li className="info-list__list">
            <span className="info-list__label">
              <MdStar />
              <FormattedMessage id="layer.metadata.qlty" />
            </span>
            <span className="info-list__value"><FormattedMessage id={ metadata.quality } /></span>
          </li>
        </InfoList>
        <InfoLink href={ metadata.more_info } target="_blank"><MdInfo /><FormattedMessage id="layer.metadata.info" /></InfoLink>
        <InfoLink href={ metadata.download } target="_blank"><MdCloudDownload /><FormattedMessage id="layer.metadata.download" /></InfoLink>
      </InfoContent>
    );
  }

  render() {
    const { onClickAddLayer } = this.props
    const { activeLayer } = this.state

    return (
      <LayerContainer>
        <BoxTitle>
          <FormattedMessage id="layer" />
        </BoxTitle>
        <TableList hover responsive size='sm' itemsLength={ this.props.layers.layers.length }>
          <SortableList
            {...this.props}
            useDragHandle
            helperClass="sortableHelper"
            onSortEnd={onSort(this.props)}
            onMetadataClick={ this.setActiveLayer.bind(this) }
          />
        </TableList>
        <ButtonAddLayer onClick={onClickAddLayer.bind(this)}>
          <MdAdd /><FormattedMessage id="layer.opt.add" />
        </ButtonAddLayer>
        <Modal
          className='modal-lg'
          title='layer.opt.metadata'
          onToggle={ this.removeActiveLayer.bind(this) }
          show={ !!activeLayer }
        >
          { activeLayer && this.renderMetadataContent() }
        </Modal>
      </LayerContainer>
    )
  }
}

export default LayerBox



// WEBPACK FOOTER //
// ./src/components/molecules/LayerBox/LayerBox.js